import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import SimplifiedSignup from '@/components/SimplifiedSignup';
import TrueMedOfferConfig from '@/components/SimplifiedSignup/configs/TrueMedOffer/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { shapeConfigForParams } from '@/components/SimplifiedSignup/Context/utils';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const TrueMedOfferPage = () => {
	return (
		<Layout pageName="truemed-offer">
			<SimplifiedSignupContextProvider flowConfig={TrueMedOfferConfig}>
				<SimplifiedSignup />
			</SimplifiedSignupContextProvider>
		</Layout>
	);
};

export default TrueMedOfferPage;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		shapeConfigForParams(TrueMedOfferConfig),
	);

	return {
		props: {
			initialState,
		},
	};
};
